module.exports = __webpack_public_path__ + "static/media/sign-out-icon.dbf92674.svg";